import React, { useEffect, useRef } from 'react';
import { injectIntl } from 'react-intl';
import _ from 'lodash';
import AsyncSelect from 'react-select/async';
import { SelectStyles as baseStyles } from '../../../../style/components/react-select';
import classNames from 'classnames';
import { getLOVListItems } from '../../../utils/piction';

const SearchableSelectInput = ({
  id,
  handleInputChange,
  metaTag,
  fileIndex,
  tagIndex,
  userInput,
  intl,
  error,
  setError,
  validateInput,
  hasTriedSubmitting,
}) => {
  // TODO: ismulti is not working because the json response is missing the core_type value
  const isMulti = _.toUpper(metaTag.meta.valueType) === 'KEYWORD';
  const rfieldDelim = metaTag.extra?.rfield_delimeter || ',';
  const isMandatory = metaTag.attributes?.mandatory === 'T';
  const searchTimeoutRef = useRef(null);
  const displayValues = (() => {
    if (!userInput || (Array.isArray(userInput) && userInput.length === 0)) {
      return isMulti ? [] : null;
    }
    if (isMulti) {
      return _.map(_.split(_.trimStart(userInput, rfieldDelim), rfieldDelim),
      val => ({ value: val, label: val }));
    }
    return { value: userInput, label: userInput };
  })();

  const getSearchList = (input) => {
    return new Promise((resolve) => {
      if (searchTimeoutRef.current) {
        clearTimeout(searchTimeoutRef.current);
      }
      searchTimeoutRef.current = setTimeout(() => {
        Promise.resolve(
          getLOVListItems(input, metaTag.attributes['mrec.lov_cc_tag_cc'])
        ).then(resolve);
      }, 1000);
    });
  };

  const extendedStyles = {
    ...baseStyles,
    control: (styles, { isDisabled, isFocused, isSelected }) => ({
      ...baseStyles.control(styles, { isDisabled, isFocused, isSelected }),
      borderColor: error
        ? 'red'
        : isSelected || isFocused
        ? '#5e2064'
        : '#ced4da',
      '&:hover': {
        borderColor: error ? 'red' : '#5e2064',
      },
    }),
  };

  useEffect(() => {
    if (hasTriedSubmitting > 0) validateInput(userInput);
  }, [hasTriedSubmitting]);

  useEffect(() => {
    if (userInput?.length != 0) setError('');
  }, [userInput]);

  return (
    <>
      <AsyncSelect
        className={classNames(error && 'input-error')}
        id={'meta_' + metaTag.meta.id}
        key={id}
        clearable={!isMandatory}
        name={metaTag.meta.name}
        value={displayValues}
        onChange={(e) => {
          setError('');
          if (isMulti) {
            const values = Array.isArray(e) ? e.map((item) => item.value) : [];
            handleInputChange(fileIndex, tagIndex, values);
            return;
          }
          handleInputChange(fileIndex, tagIndex, e?.value || '');
        }}
        loadOptions={getSearchList}
        openOnClick
        isMulti={isMulti}
        required={isMandatory}
        placeholder={intl.formatMessage({ id: 'general.select' })}
        styles={extendedStyles}
        noOptionsMessage={() => "No options found"}
        onBlur={() => validateInput(userInput)}
        error={error}
      />
      {error && <div className="error-message">{error}</div>}
    </>
  );
};

export default injectIntl(SearchableSelectInput);
